import { StackedCellValue } from './stacked-cell-value';
import { formatNumber } from '@/lib/formatUtils';
import CellFieldV2 from '../cell-field-v2';

type ConversionQuantityFieldV2Props = {
  row: any;
  onCellValueChange?: (rowUuid: string, field: string, newValue: any) => void;
  disabled?: boolean;
  showConversionInEdit?: boolean;
  commitOnBlur?: boolean;
  error?: string;
  errorDisplay?: 'message' | 'tooltip' | 'none';
};

export function ConversionQuantityFieldV2({
  row,
  onCellValueChange,
  disabled = false,
  showConversionInEdit = false,
  commitOnBlur = false,
  error,
  errorDisplay
}: ConversionQuantityFieldV2Props) {
  const qdDvt = row.ma_vt_data?.quy_doi_dvt_data?.find((item: any) => item.dvt === row.dvt);
  const heSo = qdDvt?.he_so;
  const soLuongQuyDoi = Math.round(row.so_luong * heSo * 1000) / 1000;
  const secondaryText =
    heSo > 0 && row.so_luong > 0 && soLuongQuyDoi > 0
      ? `=${formatNumber(soLuongQuyDoi)}(${row.ma_vt_data?.dvt_data?.ten_dvt})`
      : null;
  const isReadOnlyDisplay = disabled || !onCellValueChange;
  const shouldShowSecondaryInEdit = !isReadOnlyDisplay && showConversionInEdit && Boolean(secondaryText);

  return (
    <div
      className={
        shouldShowSecondaryInEdit
          ? 'flex min-h-0 w-full flex-col justify-center gap-0.5'
          : 'flex min-h-0 w-full items-center'
      }
    >
      {isReadOnlyDisplay ? (
        <StackedCellValue primary={formatNumber(row.so_luong) || null} secondary={secondaryText} primaryAlign='right' />
      ) : (
        <>
          <CellFieldV2
            name='so_luong'
            type='number'
            value={row.so_luong}
            placeholder='0'
            disabled={disabled}
            commitOnBlur={commitOnBlur}
            onValueChange={newValue => onCellValueChange?.(row.uuid, 'so_luong', newValue)}
            error={error}
            errorDisplay={errorDisplay}
          />
          {shouldShowSecondaryInEdit ? (
            <p className='truncate whitespace-nowrap text-right text-[10px] font-semibold leading-[14px] text-green-600'>
              {secondaryText}
            </p>
          ) : null}
        </>
      )}
    </div>
  );
}
